import { GROUP_NAME } from '@greenkub-fronts/shared/interface';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const initDocumentsSpacePage = createAsyncThunk(
  'initDocumentsSpacePage',
  async (
    data: { projectId: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    const projectId = parseInt(data.projectId);

    dispatch(extra.apiSlice.endpoints.getDocumentCategories.initiate());

    dispatch(extra.apiSlice.endpoints.getStandardizeDocuments.initiate());

    dispatch(
      extra.apiSlice.endpoints.getProjectById.initiate(
        {
          projectId,
          groupName: GROUP_NAME.FULL_PROJECT,
        }
        // {
        //   forceRefetch: true,
        // }
      )
    );

    dispatch(
      extra.apiSlice.endpoints.getDocumentsByProject.initiate(
        {
          projectId,
          groupName: GROUP_NAME.PROJECT_DOCUMENT_PAGE,
        }
        // {
        //   forceRefetch: true,
        // }
      )
    );

    return true;
  }
);
